export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAbcpaN9c_91ri2h3Mjy95W0jZGUWU9bJg',
    authDomain: 'yard-hostle.firebaseapp.com',
    projectId: 'yard-hostle',
    storageBucket: 'yard-hostle.appspot.com',
    messagingSenderId: '410765700808',
    appId: '1:410765700808:web:9e859f74a2939b4b35bffd',
  },
  addClient: 'ca-pub-3843031759189649',
  server: {
    mainURL: 'https://test.avs-api.com/yard-hostler/',
    socketUrl: "wss://test.avs-api.com/",
    serverURL: 'https://test.avs-api.com/',
    domain: 'https://yardhostle.com/',
    key: 'a3a625d133af5abf650ba9c701381d9c',
    project: 'yard_hostler',
    auth_token: 'yh_token',
    verification: 'yh_verification'

  },
};
